import { QUERY_NAME, SERVICES } from "@lhd/constants";
import axiosInstanceV2 from "@lhd/libs/axiosV2";
import { getCompanyId } from "@lhd/utility";
import { useQuery } from "@tanstack/react-query";

export type SalaryWorkerFilterConfig = {
  filter_status?: string[];
  filter_category?: string[];
};

export const buildSalaryWorkerFilterParams = (
  filterConfig?: SalaryWorkerFilterConfig,
) => ({
  filter_status: filterConfig?.filter_status ?? [],
  filter_category: filterConfig?.filter_category ?? [],
});

export const fetchSalaryWorkers = async (
  companyId: string | number,
  filterConfig?: SalaryWorkerFilterConfig,
) => {
  const { filter_status, filter_category } =
    buildSalaryWorkerFilterParams(filterConfig);

  return await axiosInstanceV2({
    method: "get",
    url: SERVICES.WORKERS_SALARY_LIST,
    params: {
      company_id: companyId,
      filter_status,
      filter_category,
    },
  }).then((res) => res.data || []);
};

export const useFetchSalaryWorkerOptions = (
  filterConfig?: SalaryWorkerFilterConfig,
  options?: { enabled?: boolean },
) => {
  const companyId = getCompanyId();
  const { filter_status, filter_category } =
    buildSalaryWorkerFilterParams(filterConfig);

  return useQuery(
    [
      QUERY_NAME.WORKERS,
      "salary_worker_pulldown",
      companyId,
      filter_status,
      filter_category,
    ],
    () => fetchSalaryWorkers(companyId, filterConfig),
    {
      staleTime: 0,
      cacheTime: 300,
      enabled: !!companyId && (options?.enabled ?? true),
    },
  );
};
